import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

export const SearchResultContainer = ({ search }) => {
  const { isGridView, setIsGridView } = useContext(GlobalContext);
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="subcategory-title subcategory-pro-list">
          <h4
            dangerouslySetInnerHTML={{
              __html: search,
            }}
          ></h4>
          <div className="sort-filters">
            <div className="card-row">
              <a
                href=""
                role="button"
                className={`grid-products ${isGridView ? "active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  setIsGridView(true);
                }}
              >
                <span className="wes-card-filter" />
              </a>
              <a
                href=""
                role="button"
                className={`row-products ${isGridView ? "" : "active"}`}
                onClick={(e) => {
                  e.preventDefault();
                  setIsGridView(false);
                }}
              >
                <span className="wes-row-filter" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
